export default "__VITE_ASSET__f43b4562__"